import { initScrollClasses, initModal, cloneMenu, initNavbarSbOffset, initAfterInteract } from "./functions/core";
import { initDatalayer, readCookiePermissions, readCookie, initCookiesBox } from "./functions/cookies";
import { validateFormBootstrap } from "./functions/forms/validation";

import { initJquery } from "./functions/initializers/jquery";
import { initSelect2 } from "./functions/initializers/select2";
import { initDatepicker } from "./functions/initializers/datepicker";
import { toggleCollapseOnParent } from "./functions/initializers/parent-collapse";
import { initViewer } from "./functions/initializers/viewer";
import { initTimepicker } from "./functions/initializers/timepicker";
import { initFileInput } from "./functions/initializers/file-input";
import { initSwiper } from "./functions/initializers/swiper";
import { initLines } from "./functions/initializers/line-animation";
import { initMarquee } from "./functions/initializers/marquee";
import { initGsap } from "./functions/initializers/gsap";
import { initBootstrap } from "./functions/initializers/bootstrap";


// Add functions to the global window object to give access to backend devs
document.addEventListener("DOMContentLoaded", async () => {
	console.log("Developed by LOBA - https://www.loba.com/");

	//=== Core ===//

	initScrollClasses('.header')
	window.initModal = initModal;

	//=== Cookies ===//

	initDatalayer()
	readCookiePermissions('loba_')
	window.readCookie = readCookie;
	window.initCookiesBox = initCookiesBox;

	Promise.all([
		// Swiper
		initSwiper('.swiper-from-dataset'),
		// Viewerjs
		initViewer('[data-viewer]'),
		// Custom Marquee
		initMarquee('.marquee', initViewer),
		// Line animation
		initLines('.lines-container'),
		// Allow collapse to toggle a classe on any parent element
		toggleCollapseOnParent(),
		// Prevent Scrollbar shift for menu (mainly Desktop Chrome)
		initNavbarSbOffset(),
		// Gsap
		initGsap(),
		//=== Bootstrap ===//
		initBootstrap({
			'critical': ["initCollapse"] // Collapse is critical for the menu, everything else can be lazy loaded in most cases
		})
	]).then(() => {
		window.initDatepicker = initDatepicker
	})

	//=== Non-Critical Functions ===//

	Promise.all([
		initAfterInteract([
			// Datepicker
			()=>initDatepicker('.datepicker-input'),
			// Timepicker
			()=>initTimepicker('.timepicker-input'),
			// File Input
			()=>initFileInput(".custom-file input"),
		])
	]).then(() => {
		window.initTimepicker = initTimepicker
		window.initFileInput = initFileInput;
	})

	//=== Forms ===//

	validateFormBootstrap(".needs-validation")
	
	cloneMenu('.header .navbar-desktop', '.header .navbar-mobile')
});

initJquery().then(() => {
	function runWhenDOMReady(){
		// jQuery dependant code should be placed here

		//=== Select2 ===//
		initSelect2('.custom-select-option select')
		window.initSelect2 = initSelect2;
	}

	if (document.readyState === 'interactive' || document.readyState === 'complete') { runWhenDOMReady(); } else { document.addEventListener('DOMContentLoaded', runWhenDOMReady);}
})